export default function({descriptions, tags}) {
	const _descriptions = descriptions.reduce((obj, description) => {
		let balises = {}
		obj.push(description)
		obj.push(<br key={"br-"+obj.length} />)

		tags.forEach((tag, i) => {
			let result = []

			obj.forEach((d) => {
				if (typeof d === "string") {
					d.split(tag).forEach((d, j) => {
						result.push(d)
						result.push(
							<i key={tag + " "+d}>{tag}</i>
						)
					})
					result.pop()
				} else {
					result.push(d)
				}
			})


			obj = result
		})
		return obj;
	}, [])
	return (
        <p className="description">
        	{ _descriptions }
		</p>
	)
}